module.exports = __webpack_public_path__ + "img/arrow-left-white.bb4f31ee.svg";